const countryOptions = [
  {
    value: '',
    label: '',
  },
  {
    value: 'Netherlands',
    label: 'Netherlands',
  },
  {
    value: 'Germany',
    label: 'Germany',
  },
  {
    value: 'United Kingdom',
    label: 'United Kingdom',
  },
  {
    value: 'United States',
    label: 'United States',
  },
  {
    value: 'Belgium',
    label: 'Belgium',
  },
  {
    value: 'France',
    label: 'France',
  },
  {
    value: 'Italy',
    label: 'Italy',
  },
  {
    value: 'Spain',
    label: 'Spain',
  },
  {
    value: 'Switzerland',
    label: 'Switzerland',
  },
  {
    value: 'India',
    label: 'India',
  },
  {
    value: 'Canada',
    label: 'Canada',
  },
  {
    value: 'Peru',
    label: 'Peru',
  },
  {
    value: 'Argentina',
    label: 'Argentina',
  },
  {
    value: 'Colombia',
    label: 'Colombia',
  },
  {
    value: 'Mexico',
    label: 'Mexico',
  },
  {
    value: 'Chile',
    label: 'Chile',
  },
  {
    value: 'Russia',
    label: 'Russia',
  },
  {
    value: 'China',
    label: 'China',
  },
];

const languageOptions = [
  {
    value: '',
    label: '',
  },
  {
    value: 'Dutch',
    label: 'Dutch',
  },
  {
    value: 'German',
    label: 'German',
  },
  {
    value: 'English',
    label: 'English',
  },
  {
    value: 'Spanish',
    label: 'Spanish',
  },
  {
    value: 'French',
    label: 'French',
  },
  {
    value: 'Russian',
    label: 'Russian',
  },
  {
    value: 'Italian',
    label: 'Italian',
  },
];

export {
  countryOptions,
  languageOptions,
};
